import React from 'react';
import { MapPin, Clock, DollarSign } from 'lucide-react';

const AREA_TYPE_LABELS = {
  city: 'City',
  county: 'County',
  state: 'Region',
  country: 'Country',
  custom: 'Service area',
};

const VendorServiceAreas = ({ areas = [], preview = false }) => {
  if (!areas?.length) {
    if (preview) {
      return (
        <p className="text-xs text-gray-500 italic">
          No active service areas yet. Add a location and keep it active to show it here.
        </p>
      );
    }
    return null;
  }

  return (
    <div className={preview ? '' : 'pb-6 border-b border-gray-200'}>
      {!preview && (
        <>
          <h2 className="text-lg sm:text-xl font-light text-black mb-4">Service areas</h2>
          <p className="text-sm text-gray-600 font-light mb-4">
            This vendor serves clients in the following locations.
          </p>
        </>
      )}
      <div className={`grid grid-cols-1 ${preview ? 'gap-2' : 'sm:grid-cols-2 gap-3'}`}>
        {areas.map((area) => {
          const geo = [area.city, area.state, area.country].filter(Boolean).join(', ');
          return (
            <div
              key={area.id}
              className={`flex gap-3 rounded-xl border border-gray-200 bg-gray-50/50 ${
                preview ? 'p-3 gap-2' : 'p-4'
              }`}
            >
              <div
                className={`rounded-lg bg-primary-600 text-white flex items-center justify-center flex-shrink-0 ${
                  preview ? 'w-7 h-7' : 'w-9 h-9'
                }`}
              >
                <MapPin className={preview ? 'w-3.5 h-3.5' : 'w-4 h-4'} />
              </div>
              <div className="min-w-0">
                <p className="text-sm font-medium text-gray-900">{area.area_name}</p>
                <p className="text-xs text-gray-500 mt-0.5">
                  {AREA_TYPE_LABELS[area.area_type] || 'Area'}
                  {geo ? ` · ${geo}` : ''}
                </p>
                <div className="flex flex-wrap gap-2 mt-2 text-[11px] text-gray-600">
                  {Number(area.travel_fee) > 0 && (
                    <span className="inline-flex items-center gap-0.5">
                      <DollarSign className="w-3 h-3" />
                      +${Number(area.travel_fee).toFixed(0)} travel
                    </span>
                  )}
                  {Number(area.travel_time_minutes) > 0 && (
                    <span className="inline-flex items-center gap-0.5">
                      <Clock className="w-3 h-3" />
                      ~{area.travel_time_minutes} min
                    </span>
                  )}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default VendorServiceAreas;
